import React from 'react';
import { GooglePlay, AppStore } from '../../images';
import { PandaAI } from 'shared/images/characters';
import styles from './MobilePopover.module.scss';
import { getAppScheme, Lang } from 'shared/constants';
import { Button } from '../design-system';
import classnames from 'classnames';

const appStoreLink = 'https://apple.co/34Bf5jL';
const playStoreLink = 'https://play.google.com/store/apps/details?id=com.headtotoe.app';

function MobilePopover({ children, lang = Lang.MOBILE_POPOVER }) {
  const isMobile = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i);
  const { deepLink } = useDeepLinkAutoRedirect({ disabled: !isMobile });

  if (!isMobile) {
    return children;
  }

  const redirectToApp = () => {
    window.location = deepLink;
  };

  return (
    <div className={classnames(['new-design-system', styles.root])}>
      <img src={PandaAI} className={styles.image} alt={lang.HEADER} />
      <h1 className={styles.header}>{lang.HEADER}</h1>
      <h3 className={styles.subHeader}>{lang.SUBHEADER}</h3>

      <div className={styles.download}>
        <a href={appStoreLink}>
          <img src={AppStore} className={styles.downloadButton} alt="App Store" />
        </a>
        <a href={playStoreLink}>
          <img src={GooglePlay} className={styles.downloadButton} alt="Play Store" />
        </a>
      </div>

      <label>{lang.OPEN_APP_BUTTON_LABEL}</label>
      <Button type="primary" onClick={redirectToApp} className={styles.openAppButton}>
        {lang.GO_TO_APP}
      </Button>
    </div>
  );
}

export { MobilePopover };

function useDeepLinkAutoRedirect({ disabled }) {
  const deepLink = window.location.href.replace(/(https|http)/, getAppScheme());

  const queryParms = new URLSearchParams(window.location.search);
  const isRoot = window.location.pathname === '/';
  const hasQueryParams = Array.from(queryParms.entries()).length > 0;
  disabled = disabled || (isRoot && !hasQueryParams);

  React.useEffect(() => {
    if (disabled) {
      return;
    }

    window.location = deepLink;
  }, [deepLink, disabled]);

  return {
    deepLink,
  };
}
